import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export default async function getSalesAgentDetails(salesAgentId, callback) {
	var salesAgentObj;
	var salesAgentString = `/users/${salesAgentId}`;

	firebaseRef.ref(salesAgentString).once('value', (snapshot) => {
		let salesAgent = snapshot.val();
		console.log('getSalesAgentDetails snapshot', snapshot.val());
		var name = salesAgent?.fullName;
		var email = salesAgent?.email;
		var phoneNumber = salesAgent?.phoneNumber;

		salesAgentObj = {
			name: name,
			email: email,
			phoneNumber: phoneNumber,
		};
		callback(salesAgentObj);
	});

	// return salesAgentObj;
}
